// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var mobileRouter = {
  path: '/kongqiweishi',
  component: Layout,
  redirect: '/kongqiweishi/MchPromoter',
  name: 'kongqiweishi',
  meta: {
    title: '用户管理',
    icon: 'user'
  },
  children: [{
    path: 'MchPromoter',
    component: function component() {
      return import('@/views/kongqiweishi/MchPromoter/page.vue');
    },
    name: 'MchPromoter',
    meta: {
      title: '达人招商人管理',
      icon: ''
    }
  }, {
    path: 'supplierPromoter',
    component: function component() {
      return import('@/views/kongqiweishi/supplierPromoter/page.vue');
    },
    name: 'supplierPromoter',
    meta: {
      title: '供应链招商人管理',
      icon: ''
    }
  }, {
    path: 'AirGuard',
    component: function component() {
      return import('@/views/kongqiweishi/MchPromoter/page.vue');
    },
    name: 'AirGuard',
    meta: {
      title: '生活达人管理',
      icon: ''
    }
  }, {
    path: 'PartnerCity',
    component: function component() {
      return import('@/views/kongqiweishi/MchPromoter/page.vue');
    },
    name: 'PartnerCity',
    meta: {
      title: '服务商管理',
      icon: ''
    }
  }, {
    path: 'GifReview',
    component: function component() {
      return import('@/views/kongqiweishi/GifReview/page.vue');
    },
    name: 'GifReview',
    meta: {
      title: '动图审核会员超管',
      icon: ''
    }
  }, {
    path: 'supplier',
    component: function component() {
      return import('@/views/kongqiweishi/Supplier/page.vue');
    },
    name: 'supplier',
    meta: {
      title: '品牌会员超管',
      icon: ''
    }
  }, {
    path: 'procure',
    component: function component() {
      return import('@/views/kongqiweishi/procure/page.vue');
    },
    name: 'procure',
    meta: {
      title: '城市云商超管',
      icon: ''
    }
  }, {
    path: 'designvip',
    component: function component() {
      return import('@/views/kongqiweishi/designvip/page.vue');
    },
    name: 'designvip',
    meta: {
      title: '企业会员超管',
      icon: ''
    }
  }, {
    path: 'realEstatedEvelopers',
    component: function component() {
      return import('@/views/kongqiweishi/realEstatedEvelopers/page.vue');
    },
    name: 'realEstatedEvelopers',
    meta: {
      title: '房产开发商超管',
      icon: ''
    }
  }, {
    path: 'propertyCompany',
    component: function component() {
      return import('@/views/kongqiweishi/propertyCompany/page.vue');
    },
    name: 'propertyCompany',
    meta: {
      title: '物业公司超管',
      icon: ''
    }
  }, {
    path: 'propertyOperators',
    component: function component() {
      return import('@/views/kongqiweishi/propertyOperators/page.vue');
    },
    name: 'propertyOperators',
    meta: {
      title: '楼盘运营商超管',
      icon: ''
    }
  }, {
    path: 'animationCompanies',
    component: function component() {
      return import('@/views/kongqiweishi/animationCompanies/page.vue');
    },
    name: 'animationCompanies',
    meta: {
      title: '动图公司超管',
      icon: ''
    }
  }, {
    path: 'clientManager',
    component: function component() {
      return import('@/views/kongqiweishi/clientManager/page.vue');
    },
    name: 'clientManager',
    meta: {
      title: '客户经理',
      icon: ''
    }
  }, {
    path: 'trader',
    component: function component() {
      return import('@/views/kongqiweishi/trader/page.vue');
    },
    name: 'trader',
    meta: {
      title: '操盘手',
      icon: ''
    }
  },
  // {
  //   path: 'purchaser',
  //   component: () => import('@/views/kongqiweishi/purchaser/page.vue'),
  //   name: 'purchaser',
  //   meta: { title: '城市云商超管', icon: '' }
  // },
  {
    path: 'ally',
    component: function component() {
      return import('@/views/kongqiweishi/ally/page.vue');
    },
    name: 'ally',
    meta: {
      title: '云商联营中心',
      icon: ''
    }
  }, {
    path: 'designer',
    component: function component() {
      return import('@/views/kongqiweishi/designer/page.vue');
    },
    name: 'designer',
    meta: {
      title: '设计师',
      icon: ''
    }
  }, {
    path: 'personagevip',
    component: function component() {
      return import('@/views/kongqiweishi/personagevip/page.vue');
    },
    name: 'personagevip',
    meta: {
      title: '个人会员',
      icon: ''
    }
  }, {
    path: 'dlm',
    component: function component() {
      return import('@/views/user/dlm/index');
    },
    name: 'Dlm',
    meta: {
      title: '合作会员',
      icon: ''
    }
  }, {
    path: 'trialFitting',
    component: function component() {
      return import('@/views/kongqiweishi/trialFitting/page.vue');
    },
    name: 'trialFitting',
    meta: {
      title: '试装顾问',
      icon: ''
    }
  }, {
    path: 'assistant',
    component: function component() {
      return import('@/views/kongqiweishi/assistant/page.vue');
    },
    name: 'assistant',
    meta: {
      title: '云助理管理',
      icon: ''
    }
  }, {
    path: 'customerService',
    component: function component() {
      return import('@/views/kongqiweishi/customerService/page.vue');
    },
    name: 'customerService',
    meta: {
      title: '客服管理',
      icon: ''
    }
  }, {
    path: 'cooperate',
    component: function component() {
      return import('@/views/kongqiweishi/cooperate/page.vue');
    },
    name: 'cooperate',
    meta: {
      title: '协同软件商管理',
      icon: ''
    }
  }, {
    path: 'user',
    component: function component() {
      return import('@/views/user/list/index.vue');
    },
    name: 'user',
    meta: {
      title: '2C小程序用户管理',
      icon: ''
    }
  }, {
    path: 'operation',
    component: function component() {
      return import('@/views/kongqiweishi/operationList/index.vue');
    },
    name: 'operation',
    meta: {
      title: '运营号管理',
      icon: ''
    }
  }, {
    path: 'banner/list',
    component: function component() {
      return import('@/views/kongqiweishi/systemBanner/page.vue');
    },
    name: 'bannerList',
    meta: {
      title: '广告图',
      icon: ''
    }
  }, {
    path: 'wallet_MchPromoter',
    component: function component() {
      return import('@/views/kongqiweishi/wallet/page.vue');
    },
    name: 'wallet_MchPromoter',
    meta: {
      title: '招商人钱包',
      icon: ''
    }
  }, {
    path: 'withdrawal_MchPromoter',
    component: function component() {
      return import('@/views/financial/commission/withdrawal/index');
    },
    name: 'withdrawal_MchPromoter',
    meta: {
      title: '招商人提现',
      icon: ''
    }
  }, {
    path: 'wallet_AirGuard',
    component: function component() {
      return import('@/views/kongqiweishi/wallet/page.vue');
    },
    name: 'wallet_AirGuard',
    meta: {
      title: '分销商钱包',
      icon: ''
    }
  }, {
    path: 'capital_MchPromoter/:uid',
    component: function component() {
      return import('@/views/kongqiweishi/wallet/capital/capital.vue');
    },
    name: 'capital_MchPromoter',
    meta: {
      title: '招商人资金明细',
      icon: '',
      hidden: true
    },
    hidden: true
  }, {
    path: 'withdrawal_AirGuard',
    component: function component() {
      return import('@/views/financial/commission/withdrawal/index');
    },
    name: 'withdrawal_AirGuard',
    meta: {
      title: '分销商提现',
      icon: ''
    }
  }, {
    path: 'wallet_PartnerCity',
    component: function component() {
      return import('@/views/kongqiweishi/wallet/page.vue');
    },
    name: 'wallet_PartnerCity',
    meta: {
      title: '代理商钱包',
      icon: ''
    }
  }, {
    path: 'withdrawal_PartnerCity',
    component: function component() {
      return import('@/views/financial/commission/withdrawal/index');
    },
    name: 'withdrawal_PartnerCity',
    meta: {
      title: '代理商提现',
      icon: ''
    }
  }, {
    path: 'payment_record',
    component: function component() {
      return import('@/views/kongqiweishi/wallet/payment/payment.vue');
    },
    name: 'payment_record',
    meta: {
      title: '支付报表下载',
      icon: ''
    }
  }, {
    path: 'promoter',
    component: function component() {
      return import('@/views/kongqiweishi/promoter/page.vue');
    },
    name: 'promoter',
    meta: {
      title: '旗手',
      icon: ''
    }
  }, {
    path: 'guangzhouDesign',
    component: function component() {
      return import('@/views/kongqiweishi/guangzhouDesign/page.vue');
    },
    name: 'guangzhouDesign',
    meta: {
      title: '广州设计周会员',
      icon: ''
    }
  }, {
    path: 'bussPartner',
    component: function component() {
      return import('@/views/kongqiweishi/bussPartner/page.vue');
    },
    name: 'bussPartner',
    meta: {
      title: '合伙人',
      icon: ''
    }
  }, {
    path: 'smallService',
    component: function component() {
      return import('@/views/kongqiweishi/smallService/page.vue');
    },
    name: 'smallService',
    meta: {
      title: '小店客服',
      icon: ''
    }
  }, {
    path: 'smallBoss',
    component: function component() {
      return import('@/views/kongqiweishi/smallBoss/page.vue');
    },
    name: 'smallBoss',
    meta: {
      title: '小店老板',
      icon: ''
    }
  }, {
    path: 'smallLandlord',
    component: function component() {
      return import('@/views/kongqiweishi/smallLandlord/page.vue');
    },
    name: 'smallLandlord',
    meta: {
      title: '小店房东',
      icon: ''
    }
  }]
};
export default mobileRouter;